import Registry from "../registry";
import React from "react";
import t from "tcomb-form";

const list = {
  name: "List",
  group: "Basic",
  schema: (part) => ({
    type: "list",
    of: { type: "string" },
  }),
};

Registry.register("list", list);

export default list;



// WEBPACK FOOTER //
// ./app/parts/list.js